const config = {
    api_endpoint: window.api_endpoint || './server/',
    paths_api_endpoint: window.paths_api_endpoint || './server/',
    application_root: window.application_root || '/'
};

const CONFIG = config;

export {config, CONFIG};
